<div class="d-lg-none d-block">
  <fgb-page-header
    [pageTitle]="'terms.page.title'"
    [showBalance]="false"
    [backButtonLink]="'/'"
    [showBanner]="false"
  ></fgb-page-header>
</div>

<div class="container">
  <div class="row">
    <div class="col-12">
      <div class="mt-lg-4 bg-secondary border border-grey rounded">
        <fgbcl-terms-and-conditions [type]="termsAndConditionsType" [defaultTerms]="defaultTemplate"></fgbcl-terms-and-conditions>
      </div>
    </div>
  </div>
</div>

<ng-template #defaultTemplate>
  <p class="terms-section-content text-start mb-3">Loading...</p>
</ng-template>
